import actionConstants from '../constants/';

const allMerchantsStageList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};
const pendingMerchantsStageList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const reviewRequests = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};
const updateReviewRequests = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '', 
};
const uploadBulkMerchantData = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const downloadBulkMerchantTemplate = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const bpclBulkUploadHistory = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const initialState = {
  allMerchantsStageList: { ...allMerchantsStageList },
  pendingMerchantsStageList: { ...pendingMerchantsStageList },
  reviewRequests: { ...reviewRequests },
  updateReviewRequests: {...updateReviewRequests},
  uploadBulkMerchantData: { ...uploadBulkMerchantData },
  downloadBulkMerchantTemplate: { ...downloadBulkMerchantTemplate },
  bpclBulkUploadHistory: { ...bpclBulkUploadHistory },
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function bpclReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.GET_ALL_MERCHANT_STAGE_LIST_REQUEST:
      return {
        ...state,
        allMerchantsStageList: {
          ...state.allMerchantsStageList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_ALL_MERCHANT_STAGE_LIST_SUCCESS:
      return {
        ...state,
        allMerchantsStageList: {
          ...state.allMerchantsStageList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.GET_ALL_MERCHANT_STAGE_LIST_FAILURE:
      return {
        ...state,
        allMerchantsStageList: {
          ...state.allMerchantsStageList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: 0,
        },
      };
    case actionConstants.GET_ALL_MERCHANT_STAGE_LIST_CLEAR:
      return {
        ...state,
        allMerchantsStageList: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorCode: 0,
        },
      };
    case actionConstants.GET_PENDING_MERCHANT_STAGE_LIST_REQUEST:
      return {
        ...state,
        pendingMerchantsStageList: {
          ...state.pendingMerchantsStageList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_PENDING_MERCHANT_STAGE_LIST_SUCCESS:
      return {
        ...state,
        pendingMerchantsStageList: {
          ...state.pendingMerchantsStageList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.GET_PENDING_MERCHANT_STAGE_LIST_FAILURE:
      return {
        ...state,
        pendingMerchantsStageList: {
          ...state.pendingMerchantsStageList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: 0,
        },
      };
    case actionConstants.GET_PENDING_MERCHANT_STAGE_LIST_CLEAR:
      return {
        ...state,
        pendingMerchantsStageList: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorCode: 0,
        },
      };
      case actionConstants.GET_REVIEW_REQUESTS_REQUEST:
      return {
        ...state,
        reviewRequests: {
          ...state.reviewRequests,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_REVIEW_REQUESTS_SUCCESS:
      return {
        ...state,
        reviewRequests: {
          ...state.reviewRequests,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.GET_REVIEW_REQUESTS_FAILURE:
      return {
        ...state,
        reviewRequests: {
          ...state.reviewRequests,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: 0,
        },
      };
    case actionConstants.GET_REVIEW_REQUESTS_CLEAR:
      return {
        ...state,
        reviewRequests: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
        },
      };
    case actionConstants.UPDATE_REVIEW_REQUESTS_REQUEST:
      return {
        ...state,
        updateReviewRequests: {
          ...state.updateReviewRequests,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.UPDATE_REVIEW_REQUESTS_SUCCESS:
      return {
        ...state,
        updateReviewRequests: {
          ...state.updateReviewRequests,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.UPDATE_REVIEW_REQUESTS_FAILURE:
      return {
        ...state,
        updateReviewRequests: {
          ...state.updateReviewRequests,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: 0,
        },
      };
    case actionConstants.UPDATE_REVIEW_REQUESTS_CLEAR:
      return {
        ...state,
        updateReviewRequests: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
        },
      };
    
      case actionConstants.UPLOAD_BULK_MERCHANT_DATA_REQUEST:
      return {
        ...state,
        uploadBulkMerchantData: {
          ...state.uploadBulkMerchantData,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.UPLOAD_BULK_MERCHANT_DATA_SUCCESS:
      return {
        ...state,
        uploadBulkMerchantData: {
          ...state.uploadBulkMerchantData,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.UPLOAD_BULK_MERCHANT_DATA_FAILURE:
      return {
        ...state,
        uploadBulkMerchantData: {
          ...state.uploadBulkMerchantData,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: 0,
        },
      };
      case actionConstants.UPLOAD_BULK_MERCHANT_DATA_CLEAR:
        return {
            ...state,
            uploadBulkMerchantData: {
              isLoading: false,
              isSuccess: false,
              isFailure: false,
              data: {},
              errorCode: 0,
            },
          };
        case actionConstants.DOWNLOAD_BULK_MERCHANT_TEMPLATE_REQUEST:
      return {
        ...state,
        downloadBulkMerchantTemplate: {
          ...state.downloadBulkMerchantTemplate,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.DOWNLOAD_BULK_MERCHANT_TEMPLATE_SUCCESS:
      return {
        ...state,
        downloadBulkMerchantTemplate: {
          ...state.downloadBulkMerchantTemplate,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.DOWNLOAD_BULK_MERCHANT_TEMPLATE_FAILURE:
      return {
        ...state,
        downloadBulkMerchantTemplate: {
          ...state.downloadBulkMerchantTemplate,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: 0,
        },
      };
    case actionConstants.DOWNLOAD_BULK_MERCHANT_TEMPLATE_CLEAR:
      return {
        ...state,
        downloadBulkMerchantTemplate: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorCode: 0,
        },
      };
      case actionConstants.GET_BPCL_BULK_UPLOAD_HISTORY_REQUEST:
      return {
        ...state,
        bpclBulkUploadHistory: {
          ...state.bpclBulkUploadHistory,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_BPCL_BULK_UPLOAD_HISTORY_SUCCESS:
      return {
        ...state,
        bpclBulkUploadHistory: {
          ...state.bpclBulkUploadHistory,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.GET_BPCL_BULK_UPLOAD_HISTORY_FAILURE:
      return {
        ...state,
        bpclBulkUploadHistory: {
          ...state.bpclBulkUploadHistory,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: 0,
        },
      };
    case actionConstants.GET_BPCL_BULK_UPLOAD_HISTORY_CLEAR:
      return {
        ...state,
        bpclBulkUploadHistory: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorCode: 0,
        },
      }; 
    default:
      return {
        ...state,
      };
  }
}
